// extracted by mini-css-extract-plugin
module.exports = {"selectedSVG":"selected-svg_selectedSVG__gJlFw"};